module.exports = __webpack_public_path__ + "static/kf-section-bg-dac49cd169f76036570e1a995370220c.jpg";